<template>
    <div>
        <el-dialog title="产品用途"  :visible.sync="showUseDialog">
            <el-form :inline="true" :model="formParam" class="demo-form-inline select-wrap" :size="GCONFIG.styleElFormSize">
                <el-form-item label="名称">
                    <el-input v-model="formParam.name" placeholder="输入名称搜索"></el-input>
                </el-form-item>
                <el-form-item label="是否有效">
                    <el-select v-model="formParam.status"  filterable placeholder="是否有效">
                        <el-option v-for="item in statusData"
                                   :key="item.id"
                                   :label="item.name"
                                   :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="getProductUseList">查询</el-button>
                </el-form-item>
            </el-form>
            <el-table :data="productUseList" stripe border center :size="GCONFIG.styleTableSize" v-loading="loading" >
                <el-table-column type="index" label="序号" width="60"></el-table-column>
                <el-table-column prop="itemId" label="itemId"></el-table-column>
                <el-table-column prop="itemName" label="名称"></el-table-column>
                <!--类型   7 商城首页，5 活动，1 促销，2 套装，8 满减，9 长期订购，10 奶卡，11 赠品/换购-->
                <el-table-column label="用途">
                    <template  slot-scope="scope">
                        {{scope.row.typeName}}
                    </template>
                </el-table-column>
                <el-table-column label="状态">
                    <template  slot-scope="scope">
                        {{scope.row.statusName}}
                    </template>
                </el-table-column>
                <el-table-column prop="beginTime" label="开始时间"></el-table-column>
                <el-table-column prop="endTime" label="结束时间"></el-table-column>

                <el-table-column label="操作" fixed="right" width="250">
                    <template slot-scope="scope">
                        <el-button type="primary" size="mini" @click="handleCheck(scope.row)">查看</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination-wrap">
                <el-pagination
                    background
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="formParam.currentPage"
                    :page-sizes="GCONFIG.pageSizes"
                    :page-size="formParam.pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="totalRecord">
                </el-pagination>
            </div>

        </el-dialog>
    </div>
</template>
<script>
    //导入 HTTP请求方法
    import {
        getProductCheckUseList,
    } from '../api/api'

    //定义组件
    export default {
        data() {
            return {
                showUseDialog:false,
                productUseList:[],
                loading:false,
                totalRecord:0,
                statusData:[{"id":1,"name":"是"},{"id":null,"name":"全部"}],
                formParam: {
                    proId:'',
                    currentPage: 1,
                    status:1,
                    name:'',
                    pageSize: 10,
                },
                typeObject:{
                    1:{name:'促销',url:'/promotionlist/detail/'},
                    2:{name:'套装',url:'/grouplist/detail/'},
                    5:{name:'活动',url:'/activemanagement'},
                    7:{name:'商城首页',url:'/indexnavlist'},
                    8:{name:'满减',url:'/fullcut/detail/'},
                    9:{name:'长期订购',url:'/regular'},
                    10:{name:'奶卡',url:'/cardbatch'},
                    11:{name:'赠品换购',url:'/free/detail/'},
                }
            }
        },
        props: ['itemId', 'itemType'],
        //挂载时候执行
        mounted() {

        },
        methods: {
            openProductUse(val){
                console.log(123)
                this.showUseDialog = true
                this.formParam.proId = val.proId
                this.getProductUseList()
            },
            getProductUseList(){
                this.loading = true;
                getProductCheckUseList(this.formParam).then((res) => {
                    this.loading = false;
                    if (res.data.status == 200) {
                        this.productUseList = res.data.value.list;
                        this.totalRecord = res.data.value.total;
                    }
                })
            },
            handleSizeChange(val) {
                this.formParam.pageSize = val;
                this.getProductUseList()
            },
            handleCurrentChange(val) {
                this.formParam.currentPage = val;
                this.getProductUseList()
            },
            handleCheck(row){
                this.showUseDialog = false
                let id = row.type==1||row.type==2||row.type==8||row.type==11?row.itemId:''
                let url = this.typeObject[row.type].url+id
                this.$router.push({
                    path:url
                })
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/productCheckUse.vue